import axios from 'axios';
/*
 * The campaigns contacts cache table module
 */
export default {
  namespaced: true,
  state: {
    contacts: [],
    error: null,
    total: 0,
    isLoaded: false,
    limit: 15,
    skip: 0,
    campaignId: 0,
  },

  mutations: {
    setContacts(state, payload) {
      state.contacts = payload;
    },
    setTotal(state, payload) {
      state.total = payload;
    },
    setCampaignContactsError(state, payload) {
      state.error = payload;
    },
    setIsLoaded(state, payload) {
      state.isLoaded = payload;
    },
    setLimit(state, payload) {
      state.limit = payload;
    },
    setSkip(state, payload) {
      state.skip = payload;
    },
    setCampaignId(state, payload) {
      state.campaignId = payload;
    },
    setDefaultState(state) {
      state.contacts = [];
      state.error = null;
      state.total = 0;
      state.isLoaded = false;
      state.limit = 15;
      state.skip = 0;
      state.campaignId = 0;
    },
  },

  actions: {
    async getContacts({ commit, state }) {
      let response;
      commit('setIsLoaded', false);
      try {
        const paginationQuery = `?$skip=${state.skip}&$limit=${state.limit}&$sort[FirstName,LastName]=1`
        const response = await axios.get(
          `${process.env.VUE_APP_CONTACTS_MS_BASE_URL}/campaign/${state.campaignId}/contacts${paginationQuery}`,
        );
        commit('setContacts', response.data.data);
        commit('setTotal', response.data.total);
      } catch (error) {
        commit('setCampaignContactsError', error);
      } finally {
        commit('setIsLoaded', true);
      }
    },
  },
};
